import styled, {css} from 'styled-components';
import {em} from 'polished';

import {SVGAuthors} from '../../../atoms/svgs/authors';

const BaseSection = styled.section`
    align-items: center;
    display: flex;
    font-family: ${({theme}) => theme.font?.family?.primary};
`;

export const HorizontalSection = styled(BaseSection)`
    ${SVGAuthors} {
        height: ${em(48, 16)};
    }
`;

export const VerticalSection = styled(BaseSection)`
    flex-direction: column;
    justify-content: space-between;

    ${SVGAuthors} {
        height: ${em(82, 16)};
        margin-bottom: ${em(8, 16)};
    }
`;

export const List = styled.dl`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    line-height: ${em(18, 14)};
    margin: 0 0 0 ${em(10, 14)};
    padding: 0;

    ${HorizontalSection} & {
        flex-wrap: wrap;
        font-size: ${em(14, 16)};
    }

    ${VerticalSection} & {
        flex: 0 0 ${em(18, 16)};
        font-size: ${em(16, 16)};

        @media only screen and (min-width: ${({theme}) => theme.breakpoint.desktop}) {
            font-size: ${em(20, 16)};
        }
    }
`;

export const LabelField = styled.dt`
    color: ${({theme}) => theme.color?.label};

    &::after {
        content: ' ';
        white-space: pre-wrap;
    }

    ${HorizontalSection} & {
        flex: 1 0 100%;
    }
`;

export const NameField = styled.dd`
    display: inline-block;
    font-weight: ${({theme}) => theme.font?.weight?.heavy};
    margin: 0;
    white-space: nowrap;

    &::before,
    &::after {
        white-space: pre-wrap;
    }
`;

export const Infos = styled.div<{isLast: boolean}>`
    display: flex;

    ${({isLast}) =>
        !isLast &&
        css`
            &::after {
                content: ',';
                margin-right: ${em(8, 16)};
            }
        `};
`;

export const InfoField = styled.div`
    margin-left: ${em(4, 16)};
`;
